import { create, StateCreator } from 'zustand'

interface IImageStatus {
  isHighlightedImage: boolean
  setIsHighlightedImage: (isHighlightedImage: boolean) => void
  isExpanded: boolean
  setIsExpanded: (isExpanded: boolean) => void
  expandedHeight: number
  setExpandedHeight: (expandedHeight: number) => void
  reset: () => void
}

const createImageStatusStore: StateCreator<IImageStatus> = (set) => ({
  isHighlightedImage: false,
  setIsHighlightedImage: (isHighlightedImage) => set({ isHighlightedImage }),
  isExpanded: false,
  setIsExpanded: (isExpanded) => set({ isExpanded }),
  expandedHeight: 0,
  setExpandedHeight: (expandedHeight) => set({ expandedHeight }),
  reset: () =>
    set({ isHighlightedImage: false, isExpanded: false, expandedHeight: 0 }),
})

export const useImageStatusStore = create<IImageStatus>(createImageStatusStore)
